export default "__VITE_ASSET__CRrmFPkf__"